module.exports = __webpack_public_path__ + "static/media/ot_6.10605a77.JPG";